import Vue from 'vue'
import Router from 'vue-router'
import page from './views/page.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'page',
      component: page
    },
    {
      path: '/page-offer',
      name: 'pageOffer',
      component: () => import(/* webpackChunkName: 'page-offer' */ './views/page-offer.vue'),
    },
    {
      path: '/page-offer-his',
      name: 'pageOfferHis',
      component: () => import(/* webpackChunkName: 'page-offer-his' */ './views/page-offer-history.vue'),
    },
    {
      path: '/sku-price',
      name: 'sku-price',
      component: () => import(/* webpackChunkName: 'sku-price' */ './views/sku-price.vue'),
    },
    {
      path: '/page-offer-dis',
      name: 'pageOfferDis',
      component: () => import(/* webpackChunkName: 'page-offer-dis' */ './views/page-offer-distributor.vue'),
    },
    {
      path: '/receive-offer',
      name: 'receive-offer',
      component: () => import(/* webpackChunkName: 'receive-offer */ './views/page-receive-offer.vue'),
    },
  ]
})

